// ============ UTILIDADES ============
// This bicycle API returns timestamps five hours ahead of the recorded instant.
// Compensate only when rendering; keep the raw API values unchanged.
const API_CLOCK_OFFSET_MS = 5 * 60 * 60 * 1000;
const displayDate = (value) => new Date(new Date(value).getTime() - API_CLOCK_OFFSET_MS);
export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = displayDate(dateString);
    if (isNaN(date.getTime())) return "N/A";
    return date.toLocaleDateString("es-CO", {
      timeZone: "America/Bogota",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "N/A";
  }
};

export const formatTime = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = displayDate(dateString);
    if (isNaN(date.getTime())) return "N/A";
    return date.toLocaleTimeString("es-CO", {
      timeZone: "America/Bogota",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch {
    return "N/A";
  }
};
